<app-page-header title="Booking"></app-page-header>

<iframe [src]="booking_url | safeUrl" width='100%' height='1600px' scrolling='yes' style='border:0'></iframe>